import React from 'react';
export function Footer() {
  return <footer className="bg-verdeOscuro text-white py-16 px-4 text-center" data-id="element-79" data-mp="19j53x54emoij">
      <div className="max-w-4xl mx-auto" data-id="element-80" data-mp="206j4fl6s0ffg">
        <p className="text-lg md:text-xl font-medium mb-4 flex items-center justify-center gap-2" data-id="element-81" data-mp="209nhz964snis">
          🧘 YOGA 360 — El sistema de planificación N°1 para profesores de yoga.
        </p>

        <p className="text-gray-400 italic mb-12 max-w-2xl mx-auto" data-id="element-82" data-mp="2a3nqzm4jacws">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </p>

        <div className="mb-12" data-id="element-83" data-mp="1hiw9saxvr35z">
          <h3 className="text-2xl font-bold tracking-widest mb-6" data-id="element-84" data-mp="1w5z82ju11fud">
            🧘 YOGA 360™
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-gray-300" data-id="element-85" data-mp="1rfituxidtq6y">
            <a href="mailto:contacto@yoga360.com.ar" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-86" data-mp="13p4wcrh12z4z">
              📧 contacto@yoga360.com.ar
            </a>
            <span className="hidden md:inline text-gray-600" data-id="element-87" data-mp="1ehapwwczpk5t">|</span>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-88" data-mp="1ij5pnwf9vphh">
              📲 @yoga360.ar
            </a>
            <span className="hidden md:inline text-gray-600" data-id="element-89" data-mp="1s9h4wf4epl3o">|</span>
            <a href="#" className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-90" data-mp="1s8p8x36wdlcv">
              🌐 www.yoga360.ar
            </a>
          </div>
        </div>

        <div className="text-sm text-gray-500 border-t border-gray-800 pt-8" data-id="element-91" data-mp="zmw64tllq6q3">
          <p className="mb-2" data-id="element-92" data-mp="14ibhnew4zqjc">
            © YOGA 360™ 2025 — Todos los derechos reservados.
          </p>
          <p className="mb-2" data-id="element-93" data-mp="19kak8mk1yjf8">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-94" data-mp="2ky5ylt34uo5e">
            El material incluye ejercicios graficados. Las imágenes mostradas
            son completamente ilustrativas y pueden no coincidir exactamente con
            el texto.
          </p>
        </div>
      </div>
    </footer>;
}